import Quill from 'quill';
const BlockEmbed: any = Quill.import("blots/block/embed");
const Link: any = Quill.import("formats/link");

export class EmbedVideo extends BlockEmbed {
    static blotName = "embed-video";
    static tagName = "DIV";
    static className = "embed-video";

    input: any;
    frameborder: any;
    allowfullscreen: any;
    allow: any;
    title: any;
    referrerpolicy: any;
    src: any;
    width: any;
    height: any;

    static create(value: any) {
        const node = super.create();
    
        // Check if value is an object containing the necessary properties
        if (typeof value === 'object' && value.src) {
            const child = document.createElement("iframe");
            // setAttribute dynamically
            for (let i = 0; i < Object.keys(value).length; i++) {
                const key = Object.keys(value)[i];
                if (value[key] != null) child.setAttribute(key, String(value[key]));
            }
            
            child.classList.add("embed-video-item");
            node.appendChild(child);
        } else {
            node.innerHTML = '<div class="embed-video"></div>'; // fallback in caso di valore non valido
        }
    
        return node;
    }

    static sanitize(url: any) {
        return Link.sanitize(url);
    }

    static value(domNode: any) {
        try {
            const iframe = domNode.querySelector('iframe');
            if (!iframe) return null;
            return this.parseIframeAttributes(iframe.outerHTML);
        } catch (error) {
            console.error('Error parsing iframe attributes:', error);
            return null;
        }
        
    }

    static parseIframeAttributes(iframeString: any) {
        if (typeof DOMParser !== 'undefined') {
            const doc = new DOMParser().parseFromString(iframeString, 'text/html');
            const iframe = doc.querySelector('iframe');
            if (iframe) {
                return Array.from(iframe.attributes).reduce((attributes: any, attribute) => {
                    attributes[attribute.name] = attribute.value || 'true';
                    return attributes;
                }, {});
            }
        }

        const attributes: any = {};
        const regex = /([\w-]+)(?:=["']([^"']*)["'])?/g;
        let match;
    
        // Usa l'espressione regolare per trovare tutti gli attributi nell'iframe
        while ((match = regex.exec(iframeString)) !== null) {
            const attributeName = match[1];
            const attributeValue = match[2] || 'true';
            attributes[attributeName] = attributeValue;
        }
    
        return attributes;
    }
}

Quill.register(EmbedVideo);
